import AppManagerClient from '../../api/AppManagerClient';
import { IManagingVirtualAppsInstance } from '../../api/models';
import React, { useEffect, useState } from 'react';
import { VirtualAppsServerManagementView } from './VirtualAppsServerManagementView';
import { Merger } from '../../helpers/Merger';
import { VirtualAppsEnvironmentComparison } from '../Comparison/VirtualAppsEnvironmentComparison';
import { AccordionWrapper } from '../UIExtentions/Accordion';
import { Stack } from 'react-bootstrap';

export const VirtualAppsServerManagement = (props: any) => {
    const [serverApps, setServerApps] = useState(Array<IManagingVirtualAppsInstance>());
    const [isLoading, setLoadingStatus] = useState(true);
    const [webSiteName, setWebSiteName] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const applicationName = props.applicationName;

    const getServers = async (appName: string) => {
        try {
            const serversResult = await AppManagerClient.getVirtualAppsForManaging(appName);
            setServerApps(serversResult);
            setWebSiteName(Merger.merge(serversResult).siteName);
        } catch (err: any) {
            setErrorMessage(err.message);
        } finally {
            setLoadingStatus(false);
        }
    };

    useEffect(() => {
        getServers(applicationName);
    }, [applicationName]);

    return (
        <Stack gap={3}>
            <AccordionWrapper
                fitToSize={true}
                headerIcon="fa-code-compare"
                headerText="Environment Comparison"
                objectName={applicationName}
                isLoading={props.isLoading}
                errorMessage={props.errorMessage}
            >
                <VirtualAppsEnvironmentComparison data={serverApps} />
            </AccordionWrapper>
            <VirtualAppsServerManagementView
                serverApps={serverApps}
                userPrincipal={props.userPrincipal}
                isLoading={isLoading}
                errorMessage={errorMessage}
                isDataNotFound={serverApps.length === 0}
                applicationName={applicationName}
                webSiteName={webSiteName}
            />
        </Stack>
    );
};
